// extracted by mini-css-extract-plugin
export var active = "meal-planer-template-list-module--active--1df10";
export var inactive = "meal-planer-template-list-module--inactive--e5bad";
export var label = "meal-planer-template-list-module--label--3885c";
export var name = "meal-planer-template-list-module--name--a2421";
export var templateListItem = "meal-planer-template-list-module--template-list-item--55456";